import React from 'react';
import { Users, CheckCircle2, AlertCircle, IndianRupee } from 'lucide-react';

const FeeSummaryCards = ({ students = [], fees = [], loading = false }) => {
  const totalStudents = students.length;

  const assignedFees = fees.filter(
    f => f.status !== 'VOIDED' && (f.feeStructureId || (f.totalFees != null && f.totalFees > 0) || (f.items && f.items.length > 0))
  );
  const assignedCount = assignedFees.length;
  const notAssignedCount = Math.max(0, totalStudents - assignedCount);

  const totalOutstanding = fees.reduce((acc, f) => {
    if (f.status === 'VOIDED') return acc;
    const pending = f.pendingFee != null
      ? Number(f.pendingFee)
      : Math.max(0, (f.totalFees || 0) - (f.concessionAmount || 0) + (f.penaltyAmount || 0) - (f.paidFees || 0));
    return acc + pending;
  }, 0);

  const cards = [
    {
      title: 'Total Students',
      value: totalStudents,
      subtitle: 'Registered in school',
      icon: Users,
      bg: '#f8fafc',
      border: '#e2e8f0',
      text: '#0f172a',
      accent: '#3b82f6',
      iconBg: '#eff6ff'
    },
    {
      title: 'Fee Assigned',
      value: assignedCount,
      subtitle: 'Active fee liabilities',
      icon: CheckCircle2,
      bg: '#f8fafc',
      border: '#e2e8f0',
      text: '#0f172a',
      accent: '#10b981',
      iconBg: '#ecfdf5'
    },
    {
      title: 'Not Assigned',
      value: notAssignedCount,
      subtitle: 'Pending structure allocation',
      icon: AlertCircle,
      bg: '#f8fafc',
      border: '#e2e8f0',
      text: '#0f172a',
      accent: '#f59e0b',
      iconBg: '#fffbeb'
    },
    {
      title: 'Outstanding Dues',
      value: `₹${totalOutstanding.toLocaleString('en-IN')}`,
      subtitle: 'Total unpaid balance',
      icon: IndianRupee,
      bg: '#f8fafc',
      border: '#fecaca',
      text: '#b91c1c',
      accent: '#ef4444',
      iconBg: '#fef2f2'
    }
  ];

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '10px',
        marginBottom: '12px'
      }}
    >
      {cards.map((c, idx) => {
        const Icon = c.icon;
        return (
          <div
            key={idx}
            style={{
              background: c.bg,
              border: `1px solid ${c.border}`,
              borderRadius: '8px',
              padding: '10px 14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
              minHeight: '66px'
            }}
          >
            <div>
              <div
                style={{
                  fontSize: '11px',
                  fontWeight: '700',
                  color: '#64748b',
                  textTransform: 'uppercase',
                  letterSpacing: '0.4px',
                  lineHeight: 1
                }}
              >
                {c.title}
              </div>
              <div
                style={{
                  fontSize: '19px',
                  fontWeight: '800',
                  color: c.text,
                  marginTop: '4px',
                  lineHeight: 1.1
                }}
              >
                {loading ? <span style={{ opacity: 0.5, fontSize: '15px' }}>Loading...</span> : c.value}
              </div>
              <div
                style={{
                  fontSize: '10.5px',
                  color: '#94a3b8',
                  marginTop: '2px',
                  lineHeight: 1
                }}
              >
                {c.subtitle}
              </div>
            </div>
            <div
              style={{
                width: '34px',
                height: '34px',
                borderRadius: '8px',
                background: c.iconBg,
                color: c.accent,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <Icon size={18} strokeWidth={2.2} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeeSummaryCards;
